/*
 * File per la definizione dei Service Angular, ovvero oggetti che espongono funzionalita' condivise tra diversi Controller:
 * https://code.angularjs.org/1.5.8/docs/guide/services
 */
define([
    'angular'
],
    function (angular) {

        var resourceServices = angular.module('resourceServices', []);
        resourceServices.service('ResourceService', ['$log', '$http', 'AjaxService', 'CONSTANTS', ResourceService]);
        resourceServices.service('FileProvider', ['$log', '$window', '$http', 'MessageService', FileProvider]);

        /*
         * Service che definisce i metodi che effettuano chiamate AJAX
         */
        function ResourceService($log, $http, AjaxService, CONSTANTS) {

            var captchaEnabled = true;
            if (CONSTANTS.CAPTCHA_ENABLED == false || CONSTANTS.CAPTCHA_ENABLED == 'false') {
                captchaEnabled = false;
            }

            var _path = function (url, params) {
                var path = angular.copy(url);
                for (var key in params) {
                    var value = params[key];
                    path = path.replace("{" + key + "}", value);
                }
                return path;
            };

            /*
             * Metodi pubblici esposti dal Service
             */
            /*AT: esposto perche' chiamato da modello inviato*/
            this.buildPath = function (originalPath, args) {
                return _path(originalPath, args);
            };

            this.verificaCF = function (codiceFiscale) {
                // var path = _path(CONSTANTS.VERIFICA_CF, { 'codiceFiscale': codiceFiscale });
                var data =  { 'codiceFiscale': codiceFiscale }
                return AjaxService.ajaxRequest("POST", CONSTANTS.VERIFICA_CF, data);
                
            }; 

            this.codiceFiscale = function( codiceFiscale ) {
             //var path = _path( CONSTANTS.CODICE_FISCALE, { 'codFiscEnte': codiceFiscale } );
             var data = { 'codFiscEnte': codiceFiscale }
             return AjaxService.ajaxRequest("POST", CONSTANTS.CODICE_FISCALE, data);
            };

            this.getProvince = function () {
                return AjaxService.promisesGetter(CONSTANTS.GET_PROVINCE, null, null, 'province', false);
            };

            this.getComuni = function (provincia) {
                var path = _path(CONSTANTS.GET_COMUNI, { 'provincia': provincia });
                return AjaxService.promisesGetter(path, null, null, 'comuni_' + provincia, false);
            };

            this.getTipologie = function () {
                return AjaxService.promisesGetter(CONSTANTS.GET_TIPOLOGIE, null, null, 'tipologie', false);
            };

            this.getCategorie = function (tipologia) {
                var path = _path(CONSTANTS.GET_CATEGORIE, { 'tipologia': tipologia });
                return AjaxService.promisesGetter(path, null, null, 'tipologie_' + tipologia, false);
            };

            this.getCategorieSpecifiche = function (tipologia, categoria) {
                var path = _path(CONSTANTS.GET_CATEGORIE_SPECIFICHE, { 'tipologia': tipologia, 'categoria': categoria });
                return AjaxService.promisesGetter(path, null, null, 'tipologie_' + tipologia + '_' + categoria, false);
            };

            this.caricaDelega = function (data) {
                return AjaxService.ajaxRequest("POST", CONSTANTS.DO_DELEGA, data);
            };

            // this.verificaDelega = function (data) {
            //     return AjaxService.ajaxRequest("POST", CONSTANTS.VERIFICA_DELEGA, data);
            // };

            this.verificaFile = function (data) {
    		    var defContentType = $http.defaults.headers.post['Content-Type'];
    		    $http.defaults.headers.post['Content-Type'] = 'application/octet-stream';
            	var request = AjaxService.ajaxRequest("POST", CONSTANTS.VERIFICA_FILE_DELEGA, data);
            	$http.defaults.headers.post['Content-Type'] = defContentType;;
            	return request;
            };

            this.verificaVirus = function (data) {
                return AjaxService.ajaxRequest("POST", CONSTANTS.VERIFICA_VIRUS_DELEGA, data);
            };

            this.invia = function (data, inputCaptcha) {
                return AjaxService.ajaxRequest("POST", CONSTANTS.DO_INVIA + "?input-captcha=" + inputCaptcha, data);
            };

            this.inviaRichiesta = function (data, inputCaptcha) {
                var url = CONSTANTS.DO_INVIA_RICHIESTA + "?input-captcha=" + inputCaptcha;
                if (data.azione == 'ricerca') {
                    url = CONSTANTS.DO_RICERCA_INVIO + "?input-captcha=" + inputCaptcha;
                }
                return AjaxService.ajaxRequest("POST", url, data);
            };

            this.annulla = function (data, inputCaptcha) {
                return AjaxService.ajaxRequest("POST", CONSTANTS.DO_ANNULLA + "?input-captcha=" + inputCaptcha, data);
            };

            // this.checkAnnulla = function( data ) {
            //  return AjaxService.ajaxRequest( 'POST', CONSTANTS.CHECK_ANNULLA, data );
            // };

            this.variazioneRicerca = function (data, inputCaptcha) {
                return AjaxService.ajaxRequest("POST", CONSTANTS.DO_VARIAZIONE_CERCA + "?input-captcha=" + inputCaptcha, data);
            };

            this.variazioneSalva = function (data, inputCaptcha) {
                return AjaxService.ajaxRequest("POST", CONSTANTS.DO_VARIAZIONE_SALVA + "?input-captcha=" + inputCaptcha, data);
            };

            this.variazioneControlloInserimento = function (data, inputCaptcha){
                return AjaxService.ajaxRequest("POST",CONSTANTS.DO_CONTROLLO_INSERIMENTO + "?input-captcha=" + inputCaptcha, data);
            } 

            this.variazioneControlloInviaRichiesta = function (data, inputCaptcha){
                return AjaxService.ajaxRequest("POST",CONSTANTS.DO_CONTROLLO_INVIA_RICHIESTA + "?input-captcha=" + inputCaptcha, data);
            } 

            this.controlloVariazioneSalvata = function (data, inputCaptcha){
                return AjaxService.ajaxRequest("POST",CONSTANTS.DO_CONTROLLO_VARIAZIONE_SAVED + "?input-captcha=" + inputCaptcha, data);
            } 

            this.variazioneSalvaInvioDelega = function (data, inputCaptcha) {
                return AjaxService.ajaxRequest("POST", CONSTANTS.DO_VARIAZIONE_SALVA_INVIA + "?input-captcha=" + inputCaptcha, data);
            };

            this.variazioneAnnulla = function (data, inputCaptcha) {
                return AjaxService.ajaxRequest("POST", CONSTANTS.DO_VARIAZIONE_ELIMINA + "?input-captcha=" + inputCaptcha, data);
            };

            this.variazioneRichiestaAnnulla = function (data, inputCaptcha) {
                return AjaxService.ajaxRequest("POST", CONSTANTS.DO_VARIAZIONE_ELIMINA_CERCA + "?input-captcha=" + inputCaptcha, data);
            };

            this.variazioneInvio = function (data, inputCaptcha) {
                return AjaxService.ajaxRequest("POST", CONSTANTS.DO_VARIAZIONE_INVIA + "?input-captcha=" + inputCaptcha, data);
            };

            this.variazioneDownload = function (data, inputCaptcha) {
                return AjaxService.ajaxRequest("POST", CONSTANTS.DO_VARIAZIONE_DOWNLOAD + "?input-captcha=" + inputCaptcha, data);
            };
        }


        resourceServices.factory("BroadcastService", ['$rootScope', '$window', '$log', BroadcastService]);
        /*
         * Service di broadcast per aggiornare json condivisi
         */
        function BroadcastService($rootScope, $window, $log) {
            var _rootScope = $rootScope;
            return {
                startJob: function (jobName, jobDescription) {
                    //fa apparire lo spinner con un eventule descrizione del task/job
                    _rootScope.$broadcast('startJob', jobName, jobDescription);
                },
                endJob: function (jobName) {
                    //fa nasconde lo spinner e rimuove l'eventual descrizione del task/job
                    _rootScope.$broadcast('endJob', jobName);
                },
                securityError: function (jobName) {
                    //fa nasconde lo spinner e rimuove l'eventual descrizione del task/job
                    _rootScope.$broadcast('securityError', jobName);
                }
            };
        };

        function FileProvider($log, $window, $http, MessagesService) {
            return {
                openResponseInNewWindow: function (path, _params) {

                    $log.debug("Richiesto il file: " + path);

                    var urlParams = _params;
                    if (urlParams === undefined) {
                        urlParams = {};
                    }
                    urlParams["v"] = new Date().getTime();

                    var args = '';
                    for (var key in urlParams) {
                        var value = urlParams[key];
                        if (args !== '') {
                            args = args + "&";
                        }
                        args = args + key + "=" + value;
                    }
                    if (args !== '') {
                        args = "?" + args;
                    }

                    $window.open(path + args, "_self");
                }
            };
        }


        /*funzione per eliminare gli oggetti vuoti*/
        function clearEmpties(o) {
            for (var k in o) {
                if (!o[k] || typeof o[k] !== "object") {
                    continue;
                }
                // The property is an object
                clearEmpties(o[k]); // <-- Make a recursive call on the nested

                if (Object.keys(o[k]).length === 0) {
                    delete o[k]; // The object had no properties, so delete that
                }
            }
        }

        function ripulisciDatiSuperflui(dati) {
            if (dati.modello.tipo) {
                if (dati.modello.tipo === 'C' || dati.modello.tipo === 'D') {
                    if (dati.modello.richiesta.datiContabili.stampa && !dati.modello.richiesta.datiContabili.stampa.investEffet) {
                        delete dati.modello.richiesta.datiContabili.stampa;
                    }

                    if (dati.modello.richiesta.datiContabili.emittenti && !dati.modello.richiesta.datiContabili.emittenti.investEffet) {
                        delete dati.modello.richiesta.datiContabili.emittenti;
                    }
                }
            }
        }




        return resourceServices;
    });



//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/resources/js/app/services/resource-services.js
// module id = 12
// module chunks = 1